import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useContent } from "@/i18n";
import { Logo } from "./Logo";
import { EASE } from "./Reveal";

const KEY = "nlc-disclaimer-ack";

export const DisclaimerGate = () => {
  const { t } = useContent();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setOpen(true);
  }, []);

  const agree = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] flex items-end justify-center bg-navy-900/80 p-4 backdrop-blur-md sm:items-center"
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby="gate-title"
            data-testid="disclaimer-gate"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 24 }}
            transition={{ duration: 0.7, ease: EASE }}
            className="w-full max-w-xl border border-gold/40 bg-navy-800 p-8 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)] md:p-10"
          >
            <Logo />
            <p className="eyebrow mt-8">{t.gate.title}</p>
            <h2 id="gate-title" className="sr-only">{t.gate.title}</h2>
            <p className="mt-4 text-sm leading-relaxed text-paper/85">{t.gate.body}</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <button type="button" onClick={agree} data-testid="disclaimer-agree-button" className="btn-solid" autoFocus>
                {t.gate.agree}
              </button>
              <a href="https://www.google.com" data-testid="disclaimer-leave-link" className="btn-outline">
                {t.gate.leave}
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
